import React, { useEffect, useState } from "react"

import { graphql } from "gatsby"
import PropTypes from "prop-types"

import Loader from "../components/atoms/loader"
import Seo from "../components/head"
import Layout from "../components/layout"
import Subscribe from "../components/organisms/subscribe"
import UrlFunctions from "../helpers/url"

const SubscribePage = ({ data, pageContext }) => {
  const [isFullscreen, setIsFullscreen] = useState(false)
  const [state, setState] = useState("loading")

  useEffect(() => {
    const growthChannel =
      UrlFunctions.getParams().sqf_channel || UrlFunctions.getParams().utm_id

    setIsFullscreen(
      data.sanitySubscribe.fullscreen_growth_channels.includes(growthChannel)
    )

    setState("loaded")
  }, [])

  if (state === "loading") {
    return <Loader absolute />
  }

  return (
    <Layout
      fullscreen={isFullscreen}
      pageType="subscribe"
      currentVertical={data.sanitySubscribe.vertical.slug.current}
    >
      <Subscribe
        fullscreen={isFullscreen}
        defaultStep={pageContext.step}
        data={data}
      />
    </Layout>
  )
}

SubscribePage.propTypes = {
  pageContext: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
}

export default SubscribePage

const HeadComponent = ({ location, data }) => (
  <Seo title={data.sanitySubscribe.title} path={location.pathname} />
)

HeadComponent.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
}

export const Head = HeadComponent

export const pageQuery = graphql`
  query subscribeQuery($vertical: String!) {
    allSanityDictionary {
      nodes {
        key {
          current
        }
        value
      }
    }
    allSanityCountry {
      nodes {
        abbreviation
        name
      }
    }
    allSanityCity {
      nodes {
        abbreviation
        name
        country {
          abbreviation
        }
      }
    }
    allSanityConference {
      nodes {
        name
      }
    }
    bottomNav: sanityNavigation(type: { eq: "bottom" }) {
      items {
        title
        type
        url
        submenu {
          items {
            url
            title
            type
            email_subject
            email_body
            email_address
          }
        }
        email_body
        email_address
        email_subject
      }
    }
    sanitySubscribe(vertical: { slug: { current: { eq: $vertical } } }) {
      title
      vertical {
        cm_id
        color
        slug {
          current
        }
      }
      fullscreen_growth_channels
      heading {
        default
        referral
        additional
        growth_channel {
          sqf_channel
          heading
          growth_channel_details
        }
      }
      phone {
        default {
          ...ImageWithPreview
        }
        growth_channel {
          image {
            ...ImageWithPreview
          }
          growth_channel_details
          sqf_channel
        }
        referral {
          ...ImageWithPreview
        }
      }
      illustration {
        default {
          image {
            ...ImageWithPreview
          }
        }
        referral {
          image {
            ...ImageWithPreview
          }
        }
        growth_channel {
          icon {
            image {
              ...ImageWithPreview
            }
          }
          sqf_channel
          growth_channel_details
        }
      }
      description {
        _rawDefault
        _rawReferral
        growth_channel {
          sqf_channel
          growth_channel_details
          _rawDescription
        }
      }
      quotes_title
      quotes {
        quote
        attribution
      }
      press_title
      press {
        name
        url
        dark_logo {
          ...ImageWithPreview
        }
        logo {
          ...ImageWithPreview
        }
      }
      ctas {
        cta
        cta_additional
        cta_supplemental {
          text
          url
        }
        ctas {
          text
          url
        }
      }
      success {
        title
        video {
          asset {
            url
          }
        }
        _rawDefault
        _rawReferral
        growth_channel {
          sqf_channel
          growth_channel_details
          _rawDescription
        }
      }
      additional_fields {
        name
        tag
        type
        values
      }
    }
  }
`
